import React from 'react';
import { CheckIcon } from 'lucide-react';
import type { Option } from '../../types/clock';
import { formatPrix } from '../../utils/price';
type Props<T extends string | number> = {
  legend: string;
  options: Option<T>[];
  value: T;
  onChange: (value: T) => void;
  columns?: 2 | 3;
  showBasePrice?: boolean;
};
export function OptionTiles<T extends string | number>({
  legend,
  options,
  value,
  onChange,
  columns = 3,
  showBasePrice = false
}: Props<T>) {
  return <fieldset data-id="element-37" data-mp="13v299c4trvji">
      <legend className="text-sm font-medium text-ink" data-id="element-38" data-mp="13uk3now9w4yx">{legend}</legend>
      <div className={`mt-3 grid gap-2.5 ${columns === 2 ? 'grid-cols-2' : 'grid-cols-2 sm:grid-cols-3'}`} data-id="element-39" data-mp="13wwuysnx7ron">
        {options.map(option => {
        const actif = option.value === value;
        return <button key={String(option.value)} type="button" aria-pressed={actif} onClick={() => onChange(option.value)} className={`flex h-full flex-col rounded-xl border px-3.5 py-3 text-left transition-colors duration-150 ease-out ${actif ? 'border-forest bg-forest/[0.06]' : 'border-line bg-parchment hover:border-forest/40'}`} data-id="element-40" data-mp="2jcc41afrainn">
              <span className="flex items-start justify-between gap-2" data-id="element-41" data-mp="249sejpejyv7z">
                <span className="text-sm font-medium text-ink" data-id="element-42" data-mp="24bv64dvcswet">{option.label}</span>
                {actif && <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-forest" data-id="element-43" data-mp="209i33x7zrclq" />}
              </span>
              {option.detail && <span className="mt-1 text-xs leading-snug text-muted" data-id="element-44" data-mp="1qi45xw3iiovr">{option.detail}</span>}
              <span className="mt-auto pt-2 text-xs text-muted" data-id="element-45" data-mp="1ljsvpk9b2cd0">
                {showBasePrice ? formatPrix(option.prix) : option.prix > 0 ? `+ ${formatPrix(option.prix)}` : 'Inclus'}
              </span>
            </button>;
      })}
      </div>
    </fieldset>;
}